import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import Layout from '../Components/Layout/Layout';
import { addJob } from '../features/jobs/jobsSlice';
import { useNavigate } from "react-router-dom";

const AddJob = () => {
    const { register, handleSubmit, reset } = useForm();
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { postLoading, postErrorMessage, postIsError } = useSelector(state => state.jobs)

    const onSubmit = data => {

        const mainData = {
            title: data.lwsJobTitle,
            type: data.lwsJobType,
            salary: data.lwsJobSalary,
            deadline: data.lwsJobDeadline,
        }
        dispatch(addJob({ data: mainData, navigate }))
        reset()

    };

    useEffect(() => {
        if (!postLoading && postIsError) {
            alert(postErrorMessage)
        }
    }, [postLoading, postErrorMessage, postIsError,])
    return (
        <Layout>
            <main className="max-w-3xl rounded-lg mx-auto relative z-20 p-10 xl:max-w-none bg-[#1E293B]">
                <h1 className="mb-10 text-center lws-section-title">Add New Job</h1>
                <div className="max-w-3xl mx-auto">
                    <form onSubmit={handleSubmit(onSubmit)} className="space-y-6">
                        <div className="fieldContainer">
                            <label for="lws-JobTitle" className="text-sm font-medium text-slate-300">Job Title</label>
                            <select id="lws-JobTitle" name="lwsJobTitle" {...register("lwsJobTitle", { required: true })} defaultValue=''>
                                <option value="" hidden >Select Job</option>
                                <option>Software Engineer</option>
                                <option>Software Developer</option>
                                <option>Full Stack Developer</option>
                                <option>MERN Stack Developer</option>
                                <option>DevOps Engineer</option>
                                <option>QA Engineer</option>
                                <option>Product Manager</option>
                                <option>Social Media Manager</option>
                                <option>Senior Executive</option>
                                <option>Junior Executive</option>
                                <option>Android App Developer</option>
                                <option>IOS App Developer</option>
                                <option>Frontend Developer</option>
                                <option>Frontend Engineer</option>
                            </select>
                        </div>

                        <div className="fieldContainer">
                            <label for="lws-JobType">Job Type</label>
                            <select id="lws-JobType" name="lwsJobType" required {...register("lwsJobType", { required: true })} defaultValue=''>
                                <option value="" hidden >Select Job Type</option>
                                <option>Full Time</option>
                                <option>Internship</option>
                                <option>Remote</option>
                            </select>
                        </div>

                        <div className="fieldContainer">
                            <label for="lws-JobSalary">Salary</label>
                            <div className="flex border rounded-md shadow-sm border-slate-600">
                                <span className="input-tag">BDT</span>
                                <input step='any' {...register("lwsJobSalary", { required: true, })} type="number" name="lwsJobSalary" id="lws-JobSalary" required className="!rounded-l-none !border-0"
                                    placeholder="20,00,000" />
                            </div>
                        </div>

                        <div className="fieldContainer">
                            <label for="lws-JobDeadline">Deadline</label>
                            <input {...register("lwsJobDeadline", { required: true, })} type="date" name="lwsJobDeadline" id="lws-JobDeadline" required />
                        </div>

                        <div className="text-right">
                            <button disabled={postLoading} type="submit" id="lws-submit" className="cursor-pointer btn btn-primary w-fit">
                                Submit
                            </button>
                        </div>
                    </form>
                </div>
            </main>
        </Layout>
    );
};

export default AddJob;